import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.3/js/sparta-ui-layers-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.3.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.5/js/sparta-validation-framework";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import "utilities/vendor/jsencrypt/2.3.1/js/jsencrypt";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.2/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import fingerprintUtility from "utilities/login/fingerprint-utility/2.0.0/js/fingerprint-utility";
import textInput from "utilities/helpers/helpers-text-inputs/4.1.0/js/helpers-text-inputs";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import checkbox from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import checkboxHelper from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.5/js/helpers-sparta";
import radioButton from "utilities/helpers/helpers-radio-button/4.3.1/js/helpers-radio-button";
import select from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import helpersSelect from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import selectHelper from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import textAreaHelper from "utilities/helpers/helpers-textarea/2.1.1/js/helpers-textarea";
import SecureSigninController from "modules/login/ah-secure-signin-module/8.4.1/js/ah-secure-signin-controller";
import SecureSigninView from "modules/login/ah-secure-signin-module/8.4.1/js/ah-secure-signin-view";
import SecureSigninModel from "modules/login/ah-secure-signin-module/8.4.1/js/ah-secure-signin-model";
import spartaTemplates from "modules/login/ah-secure-signin-module/8.4.1/js/templates";
import "css!modules/login/ah-secure-signin-module/8.4.1/css/ah-secure-signin-module.scss.css";















export default class ahSecureSigninModuleJS extends Module {
  constructor(options) {

    Object.assign(options, {
      target: options.target,
      debug: true,
      events: {
        namespace: 'secure-signin-module',
      },
    });


    super(options);

    this.errorText = {};
    this.errorText = options.errorText;

    this.apiEndPoints = {};
    this.basePath = ahCawCommons.getBasePath(this.spaParams);
    this.endpoints = options.endpoints;
    this.apiEndPoints = ahCawCommons.getEndPoints(options.endpoints, this.basePath);
    this.jsSrc = ahCawCommons.getEndPoints(options.js, this.basePath);






  }

  init(args = {}) {

       this.setupMVC();
    const that = this;
    if (that.errorText && that.errorText !== '') {
      setTimeout(() => {
          that.Events.pub('Error-Data', that.errorText);
        }, 500);
    }





    $(this.view.settings.target).spartaInputs();
  }

  setupMVC() {
    this.eventsMaster = cawEventsMasterUtility;
    Object.assign(this.view, new SecureSigninView(this));
    Object.assign(this.model, new SecureSigninModel(this));
    Object.assign(this.controller, new SecureSigninController(this));

    this.view._initialize();
    this.model._initialize();
    this.controller._initialize();

    this._debug(this.view);
    this._debug(this.controller);
    this._debug(this.model);
  }

  buildView() {
    Object.assign(this.view, new SecureSigninView(this));
    this._debug(this.view);
  }

  buildController() {
    Object.assign(this.controller, new SecureSigninController(this));
    this._debug(this.controller);
  }

  buildModel() {
    Object.assign(this.model, new SecureSigninModel(this));
    this._debug(this.model);
  }


}
